/* src/app/components/show-remove-ingrediants-dialog/show-remove-ingrediants-dialog.component.scss */
.footer_block {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 20px;
  z-index: 99;
}
.footer_block ion-button {
  width: 100%;
  margin-top: 15px;
}
.footer_block {
  background: white;
}
.footer_block .cancel_btn {
  --background: transparent;
  border: 2px solid var(--ion-color-primary);
  border-radius: 16px;
  color: var(--ion-color-primary);
}
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: auto;
  padding: 30px 0px;
  overflow: auto;
}
.wrapper .title {
  padding: 0px 20px;
  color: var(--ion-color-secondary);
  text-transform: capitalize;
}
.content {
  width: 100%;
  height: auto;
  overflow: auto;
}
.content app-article-option-group-checkbox {
  width: 100%;
}
.wrapper-header {
  width: 100%;
  text-align: center;
}
ion-footer {
  box-shadow: none !important;
}
/*# sourceMappingURL=show-remove-ingrediants-dialog.component.css.map */
